import React, { Component } from "react";
import LogsList from "../LogsList/LogsList";
import { inject, observer } from "mobx-react";

class LogsPanel extends Component {
  constructor(props) {
    super(props);

    this.state = { customerId: this.props.customerId, logs: null };
  }

  componentDidMount() {
    this.fetchData();
  }

  async fetchData() {
    const { stores } = this.props;
    stores.data.LogsStore.fetchByCustomerId(this.state.customerId).then(() => {
      this.setState({ logs: stores.data.LogsStore._data });
    });
  }

  render() {
    return (
      <div className="col-sm-12">
        <div className="well">
          <div className="row" style={{ display: "flex", alignItems: "center" }}>
            <div className="col-sm-6">
              <h2>Logs</h2>
            </div>
            <div className="col-sm-6">
              <span className="pull-right">(shows 100 most recent logs)</span>
            </div>
          </div>
          <LogsList logs={this.state.logs} scrollable={true} />
        </div>
      </div>
    );
  }
}

export default inject("stores")(observer(LogsPanel));



// WEBPACK FOOTER //
// ./src/Components/LogsPanel/LogsPanel.js